// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8x-3";
export var contentContainer = "_8x-0";
export var editorContainer = "_8x-1";
export var quillInputForm = "_8x-2";
export var zoneDivider = "_8x-4";